import React from 'react'
import { SelectableRadio } from './SelectableRadio'
import { theme } from '../../Common/Credentials'

const RectangularTabButton = ({ label, checked, onClick, description, icon, iconColour }) => {
  const Icon = icon
  return (
    <div
      onClick={onClick}
      className={`tw-relative tw-p-4 tw-rounded-lg tw-cursor-pointer tw-transition-all tw-duration-200 tw-flex tw-items-center  ${checked
        ? theme === "classic" ? "tw-bg-[#f8f2ec] tw-border tw-border-[#4d4d4d]" : "tw-bg-[#e4f0f7] tw-border tw-border-[#3574de]"
        : "tw-bg-[#f8fafc] tw-border tw-border-[#e2e8f0]"
        }`}
    >
      {icon && <div className={(theme === "classic" ?"tw-bg-[#4d4d4d]": "tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600") +" tw-p-2 tw-mr-2 tw-rounded-md"}>
        <Icon size={12} color={"#fff"} />
      </div>}
      <div className="tw-absolute tw-top-4 tw-right-4">
        <SelectableRadio checked={checked} size="lg" color={theme === "classic" ? "#4d4d4d" : "#3574de"} />
      </div>
      <div>
        <div
          className={`tw-inline-block tw-font-semibold tw-text-[0.9rem] ${description && "tw-border-b"}  ${theme === "classic"  ? "tw-text-[#4d4d4d] tw-border-black" : "tw-text-[#3574de] tw-border-[#3574de] "
            }`}
        >
          {label}
        </div>
        {description && <div className='tw-text-[0.7rem] tw-text-[#3c4046] tw-mt-2'>
          {description}
        </div>}
      </div>
    </div>
  )
}

export default RectangularTabButton